import { filter } from 'lodash';
import { useState, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
// material
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
} from '@mui/material';
import axios from 'axios';
import IconButton from '@mui/material/IconButton';
import { id } from 'date-fns/locale';
// components
import Page from '../components/Page';
import SearchNotFound from '../components/SearchNotFound';
import { UserListHead, IndivualListToolbar, UserMoreMenu, IndustryUserDialog, IndustryUserViewDialog } from '../sections/@dashboard/user';

import Iconify from '../components/Iconify';
import Scrollbar from '../components/Scrollbar';

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });

  // Filter by email
  if (query) {
    return filter(stabilizedThis.map((el) => el[0]), (_user) =>
      _user.email.toLowerCase().includes(query.toLowerCase())
    );
  }

  return stabilizedThis.map((el) => el[0]);
}

// Updated TABLE_HEAD to include all fields from the schema
const TABLE_HEAD = [
  // View column
  { id: 'organizationName', label: 'Organization Name', alignRight: false },
  { id: 'nameofcmdOrMdOrCeo', label: 'Name of CMD/MD/CEO', alignRight: false },
  { id: 'email', label: 'Email', alignRight: false },
  { id: 'phoneno', label: 'Phone Number', alignRight: false },
  { id: 'address1', label: 'Address1', alignRight: false },
  { id: 'address2', label: 'Address2', alignRight: false },
  { id: 'city', label: 'City', alignRight: false },
  { id: 'state', label: 'State', alignRight: false },
  { id: 'postalCode', label: 'Postal Code', alignRight: false },
  { id: 'linkedin', label: 'LinkedIn Profile', alignRight: false },
  { id: 'gstnumber', label: 'GST Number', alignRight: false },
  { id: 'panNumber', label: 'PAN Number', alignRight: false },
  { id: 'yearOfEstablishment', label: 'Year of Establishment', alignRight: false },
  { id: 'regdOfficeAddress', label: 'Registered Office Address', alignRight: false },
  { id: 'factoryAddress', label: 'Factory Address', alignRight: false },
  { id: 'telephoneOffice', label: 'Telephone (Office)', alignRight: false },
  { id: 'telephoneFactory', label: 'Telephone (Factory)', alignRight: false },
  { id: 'website', label: 'Website', alignRight: false },
  { id: 'headHRD', label: 'Head of HRD', alignRight: false },
  { id: 'headOperations', label: 'Head of Operations', alignRight: false },
  { id: 'headAdministration', label: 'Head of Administration', alignRight: false },
  { id: 'products', label: 'Products', alignRight: false },
  { id: 'relatedGroupIndustries', label: 'Related Group Industries', alignRight: false },
  { id: 'turnover', label: 'Turnover', alignRight: false },
  { id: 'achievements', label: 'Achievements', alignRight: false },
  { id: 'additionalInfo', label: 'Additional Info', alignRight: false },
  { id: 'natureoforganization', label: 'Nature of Organization', alignRight: false },
  { id: 'numberOfEmployees', label: 'Number of Employees', alignRight: false },
  { id: 'howDidYouKnowAboutUs', label: 'How did you know about us?', alignRight: false },
  { id: 'membershipID', label: 'Membership ID', alignRight: false },
  { id: 'membershipCategory', label: 'Membership Category', alignRight: false },
  { id: 'tenure', label: 'Tenure', alignRight: false },
  { id: 'msmeCertificateType', label: 'MSME Certificate Type', alignRight: false },
  { id: 'msmeCertificateUpload', label: 'MSME Certificate', alignRight: false },
  { id: 'gstCertificateUpload', label: 'GST Certificate', alignRight: false },
  {
    id: 'communicationAuthority',
    label: 'Communication Authority Name',
    alignRight: false,
  },
  {
    id: 'communicationAuthority',
    label: 'Communication Authority Designation',
    alignRight: false,
  },
  {
    id: 'communicationAuthority',
    label: 'Communication Authority Phone',
    alignRight: false,
  },
  {
    id: 'communicationAuthority',
    label: 'Communication Authority Email',
    alignRight: false,
  },
  { id: 'action', label: 'Action', alignRight: false },
];
  
// ----------------------------------------------------------------------
  
export default function IndividualUser() {
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('organizationName');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [users, setUsers] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [editingUserId, setEditingUserId] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null); 
  const [openViewModal, setOpenViewModal] = useState(false);
  
  useEffect(() => {
    fetchUsers();
  }, []);
  
  const fetchUsers = async () => {
    try {
      const response = await axios.get('https://form.cpccbe.org/api/industry/memberships');
      setUsers(response.data);
      console.log(response.data);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };
  
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };
  
  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = users.map((n) => n.email);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };
  
  const handleClick = (event, email) => {
    const selectedIndex = selected.indexOf(email);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, email);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };
  
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  
  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  // Handle opening and closing of modal for editing user
  const handleOpenModal = (userId) => {
    setEditingUserId(userId);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setEditingUserId(null);
  };
  
  const handleCloseViewModal = () => {
    setOpenViewModal(false);
    setSelectedUser(null);
  };

  const handleViewUser = (user) => {
    setSelectedUser(user);
    setOpenViewModal(true);
  };

  // Handle deleting a user
  const handleDeleteUser = async (userId) => {
    if (window.confirm("Are you sure you want to delete this user?")) {
      try {
        await axios.delete(`https://form.cpccbe.org/api/industry/${userId}`); // Adjust endpoint as necessary
        fetchUsers(); // Refresh user list after deletion
      } catch (error) {
        console.error("Error deleting user:", error);
      }
    }
  };
  
  const filteredUsers = applySortFilter(users, getComparator(order, orderBy), filterName);
  
  const isUserNotFound = filteredUsers.length === 0;
  
  return (
    <Page title="Industry User">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Industry Users
          </Typography>
        </Stack>
  
        <Card>
          <IndivualListToolbar
            numSelected={selected.length}
            filterName={filterName}
            onFilterName={handleFilterByName}
          />
  
          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={users.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                    const {
                      _id,
                      organizationName,
                      nameofcmdOrMdOrCeo,
                      email,
                      phoneno,
                      address1,
                      address2,
                      city,
                      state,
                      postalCode,
                      linkedin,
                      gstnumber,
                      panNumber,
                      yearOfEstablishment,
                      regdOfficeAddress,
                      factoryAddress,
                      telephoneOffice,
                      telephoneFactory,
                      website,
                      headHRD,
                      headOperations,
                      headAdministration,
                      products,
                      relatedGroupIndustries,
                      turnover,
                      achievements,
                      additionalInfo,
                      natureoforganization,
                      numberOfEmployees,
                      communicationAuthority,
                      howDidYouKnowAboutUs,
                      membershipID,
                      membershipCategory,
                      tenure,
                      msmeCertificateType,
                      msmeCertificateUpload,
                      gstCertificateUpload,
                    } = row;
  
                    const isItemSelected = selected.indexOf(email) !== -1;
  
                    return (
                      <TableRow
                        hover
                        key={_id}
                        tabIndex={-1}
                        role="checkbox"
                        selected={isItemSelected}
                        aria-checked={isItemSelected}
                      >
                        <TableCell align="left">
                          <IconButton onClick={() => handleViewUser(row)} aria-label="view user">
                            <Iconify icon="eva:eye-fill" />
                          </IconButton>
                        </TableCell>
                        <TableCell>{organizationName || '-'}</TableCell>
                        <TableCell>{nameofcmdOrMdOrCeo || '-'}</TableCell>
                        <TableCell>{email || '-'}</TableCell>
                        <TableCell>{phoneno || '-'}</TableCell>
                        <TableCell>{address1 || '-'}</TableCell>
                        <TableCell>{address2 || '-'}</TableCell>
                        <TableCell>{city || '-'}</TableCell>
                        <TableCell>{state || '-'}</TableCell>
                        <TableCell>{postalCode || '-'}</TableCell>
                        <TableCell>{linkedin || '-'}</TableCell>
                        <TableCell>{gstnumber || '-'}</TableCell>
                        <TableCell>{panNumber || '-'}</TableCell>
                        <TableCell>{yearOfEstablishment ? new Date(yearOfEstablishment).getFullYear() : '-'}</TableCell>
                        <TableCell>{regdOfficeAddress || '-'}</TableCell>
                        <TableCell>{factoryAddress || '-'}</TableCell>
                        <TableCell>{telephoneOffice || '-'}</TableCell>
                        <TableCell>{telephoneFactory || '-'}</TableCell>
                        <TableCell>
                          {website ? (
                            <a href={website.startsWith('http') ? website : `https://${website}`} target="_blank" rel="noopener noreferrer">
                              Website
                            </a>
                          ) : '-'}
                        </TableCell>
                        <TableCell>{headHRD || '-'}</TableCell>
                        <TableCell>{headOperations || '-'}</TableCell>
                        <TableCell>{headAdministration || '-'}</TableCell>
                        <TableCell>{products || '-'}</TableCell>
                        <TableCell>{relatedGroupIndustries || '-'}</TableCell>
                        <TableCell>{turnover || '-'}</TableCell>
                        <TableCell>{achievements || '-'}</TableCell>
                        <TableCell>{additionalInfo || '-'}</TableCell>
                        <TableCell>{natureoforganization || '-'}</TableCell>
                        <TableCell>{numberOfEmployees || '-'}</TableCell>
                        <TableCell>{howDidYouKnowAboutUs || '-'}</TableCell>
                        <TableCell>{membershipID || '-'}</TableCell>
                        <TableCell>{membershipCategory || '-'}</TableCell>
                        <TableCell>{tenure || '-'}</TableCell>
                        <TableCell>{msmeCertificateType || '-'}</TableCell>
                        <TableCell>
                          {msmeCertificateUpload ? (
                            <a href={msmeCertificateUpload} target="_blank" rel="noopener noreferrer">
                              View Certificate
                            </a>
                          ) : '-'}
                        </TableCell>
                        <TableCell>
                          {gstCertificateUpload ? (
                            <a href={gstCertificateUpload} target="_blank" rel="noopener noreferrer">
                              View Certificate
                              </a>
                              ): '-'} 
                        </TableCell>
                        <TableCell>
                          {communicationAuthority ? communicationAuthority.name : '-'}
                        </TableCell>
                        <TableCell>
                          {communicationAuthority ? communicationAuthority.designation : '-'}
                        </TableCell>
                        <TableCell>
                          {communicationAuthority ? communicationAuthority.phone : '-'}
                        </TableCell>
                        <TableCell>
                          {communicationAuthority ? communicationAuthority.email : '-'}
                        </TableCell>
                        <TableCell>
                          <UserMoreMenu 
                            onEdit={() => handleOpenModal(row._id)} 
                            onDelete={() => handleDeleteUser(row._id)} 
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {isUserNotFound && (
                    <TableRow>
                      <TableCell align="center" colSpan={TABLE_HEAD.length + 1} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} />
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Scrollbar>
  
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={users.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
        <IndustryUserDialog 
          open={openModal} 
          onClose={handleCloseModal} 
          userId={editingUserId} 
          fetchUsers={fetchUsers} 
        />
        
        <IndustryUserViewDialog 
          open={openViewModal} 
          onClose={handleCloseViewModal} 
          user={selectedUser}
          userId={editingUserId}
        />
      </Container>
    </Page>
  );
}